import { useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import MatchDetailsBanner from "./MatchDetailsBanner";
import { subscribeToBookmakerData, subscribeToFancyOddsData, subscribeToMarketOddsData, unsubscribeFromBookmaker, unsubscribeFromFancyOdds, unsubscribeFromMarketOdds } from "../../../../socketClient";
import MarketOdds from "./MarketOdds";
import { resetMarketOddsState } from "../../../../AsianExchangeSrc/redux/slices/fullmarketSlice";
import { useDispatch } from "react-redux";
import "../../FullMarket/aura-suspended.css";
import BookMakerOdds from "./BookmakerOdds";
import FancyOdds from "./FancyOdds";
import { handleCancelPlaceBet } from "../../../../AsianExchangeSrc/redux/slices/placeBetSlice";
const sportsMapping = {
  4: "Cricket",
  1: "Soccer",
  2: "Tennis"
}
function CTSfullMarket() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const eventName = searchParams.get("eventName");
  const sportId = searchParams.get("eventType");
  const eventId = searchParams.get("eventId");
  const competitionId = searchParams.get("competitionId");
  const joinedMarketIds = searchParams.get("joinedMarketIds");
  const bm = searchParams.get("bm");
  const f = searchParams.get("fancy");
  const s = searchParams.get("pc");

  const sport = useMemo(() => sportsMapping[sportId] || "", [sportId, sportsMapping]);
  const timeoutRefs = useRef(new Map());

  useEffect(() => {
    if (f === "true" && sportId && eventId && competitionId) {
      subscribeToFancyOddsData({
        eventId,
        eventType: sportId,
        competitionId,
        sport: sport,
      });
      return () => unsubscribeFromFancyOdds(eventId);
    }
  }, [sportId, competitionId, eventId, sportId]);

  useEffect(() => {
    if (bm === "true" && sportId && eventId && competitionId) {
      subscribeToBookmakerData({
        eventId,
        eventType: sportId,
        competitionId,
        sport: sport,
      });
      return () => unsubscribeFromBookmaker(eventId);
    }
  }, [sportId, competitionId, eventId, sport]);

  useEffect(() => {
    if (!eventId || !sport) return;

    const subscriptionData = {
      eventId: sportId,
      eventType: sportId,
      competitionId,
      matchId: eventId,
      marketId: joinedMarketIds,
      sport,
    };

    subscribeToMarketOddsData(subscriptionData);
    return () => {
      unsubscribeFromMarketOdds(sportId, joinedMarketIds);
      dispatch(handleCancelPlaceBet());
      timeoutRefs.current?.forEach(clearTimeout);
      timeoutRefs.current.clear();
    };
  }, [eventId, sportId, competitionId, joinedMarketIds, sport]);
  
  return (
    <div className="w-full flex flex-col">
      <MatchDetailsBanner sportId={sportId} eventId={eventId} eventName={eventName} />
      <div className="w-full flex flex-col">
        <MarketOdds />
        {bm === "true" && <BookMakerOdds />}
        {(f === "true" || s === "true") && <FancyOdds f={f} s={s} />}
      </div>
    </div>
  )
}

export default CTSfullMarket